import "./quick-add.js";

/* Leaving around for reference, the hero doesn't support video
const isReduced = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;
if (!!isReduced) {
    const heroVideo = document.querySelector('.wp-block-pulp-hero video');
    if (heroVideo) {
        heroVideo.pause();
    }
}
*/

/*
Cart Badge Update
*/
/**
 * Update the cart icon badge count and aria-label.
 * @param {number} count - Current cart item count
 */
function updateCartBadge(count) {
    const cartButton = document.querySelector('[href="/cart"]');
    if (!cartButton) return;

    let badge = cartButton.querySelector('.Header__CartDot');
    if (count > 0) {
        badge.classList.add('is-visible');
    } else {
        badge.classList.remove('is-visible');
    }
}

// Listen for count updates from all cart components
document.addEventListener('cart:count:updated', (e) => {
    updateCartBadge(e.detail.count);
});

// the theme incorrectly scrolls to the wrong position for normal href="#foo" links, so we'll make a button behave like a link
const jumpLinks = document.querySelectorAll('[data-jump]');
jumpLinks.forEach(link => {
    link.addEventListener('click', (e) => {
        const targetSelector = link.getAttribute('data-target');
        const targetElement = document.querySelector(targetSelector);
        if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth' });
        } else {
            // on the landing pages, we initially jumped to the product form section, but this evolved to not always include one
            // so if we don't have that target, just move to the next section on the page.
            const nextSection = link.closest('.shopify-section')?.nextElementSibling;
            if (nextSection) {
                nextSection.scrollIntoView({ behavior: 'smooth' });
            }
        }
    });
});


// Debug: check active focus element
// document.addEventListener('focusin', (e) => {
//     console.log('Focused element:', e.target);
// }); 
